export enum ActionTypes {
  // Alumnos
  GET_ALUMNOS_CURSOS = 'gfm/alumnos/GET_ALUMNOS_CURSOS',
  SET_ALUMNOS_CURSOS = 'gfm/alumnos/SET_ALUMNOS_CURSOS',
  GET_ALUMNOS_CURSOS_COUNT = 'gfm/alumnos/GET_ALUMNOS_CURSOS_COUNT',
  SET_ALUMNOS_CURSOS_COUNT = 'gfm/alumnos/SET_ALUMNOS_CURSOS_COUNT',
  GET_EXCEL_ALUMNOS_CURSOS = 'gfm/alumnos/GET_EXCEL_ALUMNOS_CURSOS',

  GET_ALUMNOS_CURSO = 'gfm/alumnos/GET_ALUMNOS_CURSO',
  SET_ALUMNOS_CURSO = 'gfm/alumnos/SET_ALUMNOS_CURSO',

  // Cursos
  GET_CURSOS = 'gfm/alumnos/GET_CURSOS',
  SET_CURSOS = 'gfm/alumnos/SET_CURSOS',
  GET_CURSOS_COUNT = 'gfm/alumnos/GET_CURSOS_COUNT',
  SET_CURSOS_COUNT = 'gfm/alumnos/SET_CURSOS_COUNT',
  GET_EXCEL_CURSOS = 'gfm/alumnos/GET_EXCEL_CURSOS',

  GET_SOCIEDADES_CURSOS = 'gfm/alumnos/GET_SOCIEDADES_CURSOS',
  SET_SOCIEDADES_CURSOS = 'gfm/alumnos/SET_SOCIEDADES_CURSOS',

  GET_PROVINCIAS_CURSOS = 'gfm/alumnos/GET_PROVINCIAS_CURSOS',
  SET_PROVINCIAS_CURSOS = 'gfm/alumnos/SET_PROVINCIAS_CURSOS',

  GET_ESTADOS_CURSOS = 'gfm/alumnos/GET_ESTADOS_CURSOS',
  SET_ESTADOS_CURSOS = 'gfm/alumnos/SET_ESTADOS_CURSOS',

  GET_CURSOS_FILTER = 'gfm/alumnos/GET_CURSOS_FILTER',
  SET_CURSOS_FILTER = 'gfm/alumnos/SET_CURSOS_FILTER',

  REMOVE_CURSOS_FILTER = 'gfm/alumnos/REMOVE_CURSOS_FILTER',

  SET_ESTADO_CURSO = 'gfm/cursos/SET_ESTADO_CURSO',

  // Cursos cierre
  GET_REPORT_COURSES_CLOSING = 'gfm/alumnos/GET_REPORT_COURSES_CLOSING',
  SET_REPORT_COURSES_CLOSING = 'gfm/alumnos/SET_REPORT_COURSES_CLOSING',

  GET_REPORT_COURSES_CLOSING_COUNT = 'gfm/alumnos/GET_REPORT_COURSES_CLOSING_COUNT',
  SET_REPORT_COURSES_CLOSING_COUNT = 'gfm/alumnos/SET_REPORT_COURSES_CLOSING_COUNT',
  GET_EXCEL_COURSES_CLOSING = 'gfm/alumnos/GET_EXCEL_COURSES_CLOSING',

  GET_SOCIEDADES_CURSOS_CIERRES = 'gfm/alumnos/GET_SOCIEDADES_CURSOS_CIERRES',
  SET_SOCIEDADES_CURSOS_CIERRES = 'gfm/alumnos/SET_SOCIEDADES_CURSOS_CIERRES',

  GET_PROVINCIAS_CURSOS_CIERRES = 'gfm/alumnos/GET_PROVINCIAS_CURSOS_CIERRES',
  SET_PROVINCIAS_CURSOS_CIERRES = 'gfm/alumnos/SET_PROVINCIAS_CURSOS_CIERRES',
  REMOVE_CURSOS_CIERRES_FILTER = 'gfm/alumnos/REMOVE_CURSOS_CIERRES_FILTER',

  // Cache
  SET_ALL_SOCIEDADES = 'gfm/alumnos/SET_ALL_SOCIEDADES',
  // Cursos cierre
  SET_ALUMN_COURSE_SELECTED = 'SET_ALUMN_COURSE_SELECTED',

  //panel administracion
  //alta gestores
  GET_ALL_GESTORES = 'gfm/alumnos/GET_ALL_GESTORES',
  SET_ALL_GESTORES = 'gfm/alumnos/SET_ALL_GESTORES',
  SET_GET_ALL_GESTORES_REQUEST_STATUS =  'gfm/alumnos/SET_GET_ALL_GESTORES_REQUEST_STATUS',
  INSERTAR_GESTORES_CURSOS = 'gfm/alumnos/INSERTAR_GESTORES_CURSOS',
  SET_INSERTAR_GESTORES_CURSOS_REQUEST_STATUS = 'gfm/alumnos/SET_INSERTAR_GESTORES_CURSOS_REQUEST_STATUS',
  ELIMINAR_GESTORES_CURSOS = 'gfm/alumnos/ELIMINAR_GESTORES_CURSOS',
  SET_ELIMINAR_GESTORES_CURSOS_REQUEST_STATUS = 'gfm/alumnos/SET_ELIMINAR_GESTORES_CURSOS_REQUEST_STATUS',

  //alta formadores
  GET_ALL_FORMADORES = 'gfm/alumnos/GET_ALL_FORMADORES',
  SET_ALL_FORMADORES = 'gfm/alumnos/SET_ALL_FORMADORES',
  SET_GET_ALL_FORMADORES_REQUEST_STATUS =  'gfm/alumnos/SET_GET_ALL_FORMADORES_REQUEST_STATUS',
  INSERTAR_FORMADORES_CURSOS = 'gfm/alumnos/INSERTAR_FORMADORES_CURSOS',
  SET_INSERTAR_FORMADORES_CURSOS_REQUEST_STATUS = 'gfm/alumnos/SET_INSERTAR_FORMADORES_CURSOS_REQUEST_STATUS',
  ELIMINAR_FORMADORES_CURSOS = 'gfm/alumnos/ELIMINAR_FORMADORES_CURSOS',
  SET_ELIMINAR_FORMADORES_CURSOS_REQUEST_STATUS = 'gfm/alumnos/SET_ELIMINAR_FORMADORES_CURSOS_REQUEST_STATUS',


  //alta alumnos
  GET_ALL_ALUMNOS = 'gfm/alumnos/GET_ALL_ALUMNOS',
  SET_ALL_ALUMNOS = 'gfm/alumnos/SET_ALL_ALUMNOS',
  SET_GET_ALL_ALUMNOS_REQUEST_STATUS =  'gfm/alumnos/SET_GET_ALL_ALUMNOS_REQUEST_STATUS',
  INSERTAR_ALUMNOS_CURSOS = 'gfm/alumnos/INSERTAR_ALUMNOS_CURSOS',
  SET_INSERTAR_ALUMNOS_CURSOS_REQUEST_STATUS = 'gfm/alumnos/SET_INSERTAR_ALUMNOS_CURSOS_REQUEST_STATUS',
  ELIMINAR_ALUMNOS_CURSOS = 'gfm/alumnos/ELIMINAR_ALUMNOS_CURSOS',
  SET_ELIMINAR_ALUMNOS_CURSOS_REQUEST_STATUS = 'gfm/alumnos/SET_ELIMINAR_ALUMNOS_CURSOS_REQUEST_STATUS',

}
